<template>
    <div class="flex w-full min-w-0 items-center rounded-full border border-gray-200 bg-white p-1 dark:border-default dark:bg-surface-card sm:inline-flex sm:w-auto">
        <button
            v-for="option in options"
            :key="option.value"
            type="button"
            class="inline-flex h-8 flex-1 items-center justify-center whitespace-nowrap rounded-full px-3 text-xs font-semibold transition-colors sm:h-8 sm:flex-none sm:px-3 sm:text-sm"
            :class="modelValue === option.value
                ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900'
                : 'text-gray-600 hover:text-gray-900 dark:text-txt-body dark:hover:text-white'"
            @click="$emit('update:modelValue', option.value)"
        >
            {{ option.label }}
        </button>
    </div>
</template>

<script setup lang="ts">
type SortOption = {
    value: string
    label: string
    shortLabel?: string
}

defineProps<{
    modelValue: string
    options: SortOption[]
}>()

defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()
</script>
